import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons'

import api from 'common/api'
import useScid from 'common/use-scid'

const useStyles = makeStyles((theme) => ({
  sendMockAppButton: {
    width: theme.typography.pxToRem(240),
  },
  bold: {
    fontWeight: 900,
  },
}))

const InitiateApplicationVerification = ({ appConfig, refetchAppConfig, readonly }) => {
  const styles = useStyles()
  const scid = useScid()
  const [initiating, setInitiating] = useState(false)
  const [initiationError, setInitiationError] = useState('')

  const initiateAppVerification = () => {
    setInitiating(true)
    api
      .post(`/api/colleges/${scid}/integrations/application/configuration/${appConfig.id}/initiate-verification`)
      .then(() => {
        refetchAppConfig()
        setInitiating(false)
      })
      .catch(() => {
        setInitiationError(
          `We couldn't send a test application. Confirm that the Scoir test round "verification-app-round" is mapped to a round in your Slate instance and try again. If the issue persists, reach out to Scoir Support.`,
        )
        setInitiating(false)
      })
  }

  const verificationInProgress = appConfig && appConfig.verificationAppId
  const verificationComplete = appConfig && appConfig.verification && appConfig.verification.initiationVerified

  return (
    <Box mb={3}>
      <Box mb={3}>
        <Typography>
          Before getting started, confirm that the Scoir mock round <strong>verification-app-round</strong> is mapped to
          an Application Round in your Slate instance.
        </Typography>
        <Typography>When you are ready, click on the link below to initiate the application.</Typography>
      </Box>
      <Button
        className={styles.sendMockAppButton}
        color="primary"
        variant="contained"
        onClick={initiateAppVerification}
        disabled={!!verificationInProgress || initiating || verificationComplete || readonly}
      >
        <FontAwesomeIcon icon={faPaperPlane} />
        &nbsp; Send Mock Application
      </Button>
      {initiationError && (
        <Box mt={2}>
          <Typography
            variant="caption"
            color="error"
          >
            {initiationError}
          </Typography>
        </Box>
      )}
    </Box>
  )
}

InitiateApplicationVerification.propTypes = {
  appConfig: PropTypes.object.isRequired,
  refetchAppConfig: PropTypes.func.isRequired,
  readonly: PropTypes.bool,
}

export default InitiateApplicationVerification
